import { useState } from 'react';
import { apiClient } from 'config/api';

export interface AssignAreaBody {
  area: string;
  accountId: string;
}

/** Assign area logic */
const useAssignArea = () => {
  const [isError, setError] = useState(false);
  const [isLoading, setLoading] = useState(false);

  /**
   * Assigns an area to an account without assigned area
   * @param body
   * @param body.area - The area to assign
   * @param body.accountId - The id of the account to be assigned
   */
  async function postAssignArea({ area, accountId }: AssignAreaBody) {
    setError(false);
    setLoading(true);
    try {
      await apiClient.post('/v2/partner/account/bind', { area_name: area, account_id: accountId });
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  return { isError, isLoading, postAssignArea };
};

export default useAssignArea;
